import React from "react";
import { useSnackbar } from "notistack";
import { dispatch } from "../../redux/store";
import { logoutAction } from "../../redux/userSlice";
import { TypeUser } from "../../redux/userSlice";
import { logout } from "../../service/utenti";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { LogoutOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const LogoutButton = ({ user }: { user: TypeUser }) => {

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const navigate = useNavigate(); 

  const { enqueueSnackbar } = useSnackbar();

  const doLogout = async () => {

    if (isLoading === true) return;

    setIsLoading(true);

    try {

        await logout(user.token);
        dispatch(logoutAction());
        navigate("/login");

    } catch (err: any) {
      enqueueSnackbar(err.message ? err.message : err, { variant: "error" });
    } finally {
      setIsLoading(false);
    }

  };

  return (
    <List>
      <ListItem key={"logout"} disablePadding>
        <ListItemButton onClick={() => doLogout()}>
          <ListItemIcon>
            <LogoutOutlined />
          </ListItemIcon>
          <ListItemText
            primary={isLoading === true ? "Logout in corso..." : "Logout"}
          />
        </ListItemButton>
      </ListItem>
    </List>
  );
};

export default LogoutButton;
